<template>
  <transition name="modal-fade">
    <div class="overlay" v-if="mostrar">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-label">Fale Conosco</span>
          <button class="btn-fechar-modal" @click="fechar">
            ×
          </button>
        </div>

        <div class="modal-body">
          <p class="modal-descricao">
            Envie uma mensagem diretamente para o coordenador da ação <br>
            <strong>{{ tituloAcao }}</strong>.
          </p>

          <div class="form-group">
            <label for="assuntoInput">Assunto</label>
            <input id="assuntoInput" type="text" v-model="assunto" placeholder="Digite o assunto da mensagem"
              class="input-estilizado" />
          </div>

          <div class="form-group">
            <label for="mensagemInput">Mensagem</label>
            <textarea id="mensagemInput" v-model="mensagem" placeholder="Digite sua mensagem aqui..."
              class="input-estilizado" rows="7" style="resize: vertical; min-height: 180px"></textarea>
          </div>

          <div class="modal-actions">
            <button class="btn-cancelar" @click="fechar">
              Cancelar
            </button>
            <button class="btn-enviar" @click="enviarMensagem" :disabled="enviando">
              {{ enviando ? "Enviando..." : "Enviar Mensagem" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
  <ModalAviso v-if="mostrarAviso" :sucesso="avisoSucesso" :texto="textoAviso" @fecharModal="fecharAviso" />
</template>


<script setup>
import { ref, watch } from "vue";
import acaoService from "@/service/acaoService";
import ModalAviso from "@/components/common/aviso.vue";

const props = defineProps({
  mostrar: Boolean,
  acaoId: [String, Number],
  tituloAcao: String,
  emailCoordenador: String,
});

const emit = defineEmits(["fechar", "enviado"]);

const assunto = ref("");
const mensagem = ref("");
const enviando = ref(false);

const mostrarAviso = ref(false);
const avisoSucesso = ref(false);
const textoAviso = ref("");
const fecharContatoAposAviso = ref(false);

watch(
  () => props.mostrar,
  (novoValor) => {
    if (novoValor) {
      assunto.value = "";
      mensagem.value = "";
      enviando.value = false;
    }
  }
);

function fechar() {
  emit("fechar");
}

function exibirAviso(texto, sucesso, fecharContato = false) {
  textoAviso.value = texto;
  avisoSucesso.value = sucesso;
  fecharContatoAposAviso.value = fecharContato;
  mostrarAviso.value = true;
}

function fecharAviso() {
  mostrarAviso.value = false;

  if (fecharContatoAposAviso.value) {
    fecharContatoAposAviso.value = false;
    emit("enviado");
    fechar();
  }
}

async function enviarMensagem() {
  if (!assunto.value.trim() || !mensagem.value.trim()) {
    exibirAviso(
      "Por favor, preencha o assunto e a mensagem.",
      false
    );
    return;
  }

  try {
    enviando.value = true;

    await acaoService.enviarEmailCoordenador(
      props.acaoId,
      assunto.value,
      mensagem.value,
      props.emailCoordenador
    );

    exibirAviso(
      "Mensagem enviada com sucesso ao coordenador!",
      true,
      true
    );
  } catch (error) {
    exibirAviso(
      "Erro ao enviar a mensagem. Tente novamente mais tarde.",
      false
    );
  } finally {
    enviando.value = false;
  }
}
</script>


<style scoped>
.modal-content {
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}


.modal-body {
  padding: 1rem;
  background-color: var(--branco);
}

.modal-descricao {
  font-size: 1rem;
  color: var(--cinza-escuro);
  text-align: center;
  margin-bottom: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.form-group label {
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--preto);
  text-align: center;
}

.input-estilizado {
  width: 450px;
  max-width: 100%;
  padding: 10px;
  border: 1px solid var(--cinza-medio) !important;
  border-radius: 4px;
  font-size: 1rem;
}

.input-estilizado:focus {
  border-color: var(--roxo-primario);
  outline: none;
}

.modal-actions {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 10px;
}

.btn-cancelar,
.btn-enviar {
  padding: 8px 25px;
  color: var(--branco);
  border-radius: 5px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-cancelar {
  background-color: var(--vermelho-escuro);
  color: var(--branco);
}

.btn-cancelar:hover {
  background-color: var(--vermelho);
}

.btn-enviar {
  background-color: var(--roxo-primario);
  color: var(--branco);
}

.btn-enviar:hover {
  background-color: var(--roxo-medio);
}

.btn-enviar:disabled {
  background-color: var(--cinza-medio);
  cursor: not-allowed;
}

/* Transição do Modal */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-content,
.modal-fade-leave-active .modal-content {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-fade-enter-from .modal-content,
.modal-fade-leave-to .modal-content {
  transform: scale(0.95) translateY(-20px);
}

@media (max-width: 768px) {
  .form-group {
    width: 100%;
  }
}
</style>
